import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StoresService {
  private readonly http = inject(HttpClient);

  get(): Observable<Store[] | null> {
    return this.http.get<Store[]>(environment.storesApiUrl + '?brand=YES');
  }
}

export type Store = {
  _id: string;
  brand: string[];
  city: string;
  country: string;
  created_at: string;
  email: string;
  erp_id: string;
  flat: string | null;
  house: string;
  latitude: number;
  logo_url: string | null;
  longitude: number;
  name: string;
  opening_hours: {
    monday?: string;
    tuesday?: string;
    wednesday?: string;
    thursday?: string;
    friday?: string;
    saturday?: string;
    sunday?: string;
  } | null;
  partner: boolean;
  phone: string | null;
  pick_up: boolean;
  same_day_delivery: boolean | null;
  same_day_delivery_distance: number | null;
  second_phone: string | null;
  street: string;
  updated_at: string;
  visibility: boolean | null;
  warehouse_number: string | null;
  zip: string;
};
